var _path, _ellipse, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConfetti = function SvgConfetti(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.651 30.69 9.26 7.515l16.884 14.566L3.63 34C1.247 33.47.65 31.572.65 30.69Z",
    fill: "#ADDE8E"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.855,
    cy: 14.717,
    rx: 2.269,
    ry: 11.054,
    transform: "rotate(-49.879 17.855 14.717)",
    fill: "#47A436"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.44 14.466c-3.443-1.059-10.262 1.766-13.242 3.31l1.325.995c5.826-2.649 10.372-2.87 11.918-2.649.794-.53.33-1.324 0-1.656Z",
    fill: "#B7DBA1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m33.007 13.474-1.324-.662.662-1.656L34 12.15l-.993 1.325Z",
    fill: "#47A436"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m17.746 10.5-.937-1.146 1.282-1.24L19.195 9.7l-1.449.801ZM25.035 5.203 24.1 4.057l1.281-1.239 1.104 1.584-1.449.801Z",
    fill: "#53B741"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m16.426 5.867-.937-1.146 1.282-1.239 1.103 1.584-1.448.801Z",
    fill: "#47A436"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m9.262 6.352-1.125.963L6.87 6.062l1.558-1.14.834 1.43ZM28.34 21.758l-.937-1.146 1.282-1.24 1.103 1.585-1.448.801Z",
    fill: "#53B741"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.955 10.823c2.648-.53.883 2.207-.331 3.642-.267.794.552.33.995 0l1.655-2.649c.795-1.324-.551-1.655-1.324-1.655H3.302c-2.119 0 .22-1.545 1.655-2.317.993-.662.662-2.318-1.655-2.318-1.854 0-.993-1.324-.331-1.986 1.06-.794.66-.993.33-.993C-.673 4.666.54 6.299 1.644 6.85c2.648 0 2.648.441 2.317.662-3.178 1.589-2.87 2.648-2.318 2.98 1.06.529 2.649.44 3.311.33Z",
    fill: "#47A436"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.412 9.798c-2.092-2.099-2.152 1.474-1.92 3.523-.242.887-.706-.036-.908-.608l.106-3.424c.084-1.693 1.513-1.173 2.218-.702l2.415 1.616c1.932 1.293.741-1.543-.096-3.123-.501-1.21.81-2.517 2.924-1.103 1.69 1.131 1.713-.602 1.514-1.61-.482-1.37.003-1.308.305-1.106 2.33 4.356.226 5.105-1.116 4.934-2.415-1.616-2.684-1.213-2.517-.81 1.928 3.389 1 4.166.295 4.131-1.29-.163-2.684-1.213-3.22-1.718Z",
    fill: "#ADDE8E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m7.277 13.14-.993 2.318c2.649 5.827 9.049 9.711 11.918 10.925l2.649-1.324C14.759 23.205 9.264 16.34 7.277 13.14ZM4.293 20.758 3.3 23.406c2.119 4.768 5.959 6.29 7.614 6.621l2.318-.993c-4.768-1.324-7.946-6.18-8.939-8.276ZM6.615 32.343c-2.913-1.06-4.635-3.2-4.966-4.304l-.662 1.655c.795 2.12 2.98 3.31 3.973 3.642l1.655-.993Z",
    fill: "#47A436"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.916 2.877c-.665.665.11 1.103.662 1.324 2.915 1.057 2.757 7.064 2.314 9.935l.993.993c1.59-10.064-.33-11.257-1.654-12.252-.795-.53-1.656-.66-2.315 0Z",
    fill: "#98DA8D"
  })));
};
export default SvgConfetti;